"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("@emotion/react");
const useResizer_1 = __importDefault(require("./useResizer"));
const style = {
    anchor: {
        width: '2px',
        height: '100%',
        pointerEvents: 'none',
        fill: 'transparent',
    },
    innerContainer: {
        position: 'absolute',
        height: '100%',
        fill: 'transparent',
        width: '10px',
        cursor: 'e-resize',
        userSelect: 'none',
        zIndex: 99999999,
    },
};
const styles = {
    container: (0, react_1.css) `
    &:hover {
      rect:last-child {
        fill: red !important;
      }
    }
  `,
};
function SVGResizer(props) {
    const { children, disabled } = props;
    const { left, right, currentPosition, isActive } = (0, useResizer_1.default)(props);
    return ((0, jsx_runtime_1.jsxs)("g", { transform: `translate(${currentPosition.x1} 0)`, children: [typeof children === 'function'
                ? children(currentPosition, isActive)
                : children, !disabled && ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [' ', (0, jsx_runtime_1.jsx)(SVGResizerHandle, { onPointerDown: left.onPointerDown, position: 0 }), (0, jsx_runtime_1.jsx)(SVGResizerHandle, { onPointerDown: right.onPointerDown, position: Math.ceil(currentPosition.x2 - currentPosition.x1) })] }))] }));
}
exports.default = SVGResizer;
function SVGResizerHandle(props) {
    return ((0, jsx_runtime_1.jsxs)("g", { onPointerDown: props.onPointerDown, css: styles.container, style: { transform: `translateX(${props.position}px)` }, "data-no-export": "true", children: [(0, jsx_runtime_1.jsx)("rect", { x: "-5px", style: style.innerContainer }), (0, jsx_runtime_1.jsx)("rect", { x: "-2.5px", style: style.anchor })] }));
}
